import {DojoDeshi} from './DojoDeshi.js';
import {DojoTemplates} from './DojoTemplates.js';
import {Eventify} from './Eventify.js';

import {Pager} from './Pager.js';

/**
 * ClassRecord is a single record in the ClassRecordSummaryTable
 */
class ClassRecord {
	constructor(append, record) {
		[this.el, this.$] = DojoTemplates(`ClassRecordSummaryTable.Record`);
		let date = new Date(record.Start);
		this.$.date.innerText = date.toLocaleString(undefined, {year: 'numeric', month: 'short', day: 'numeric'});
		this.$.day.innerText = date.toLocaleString(undefined, {weekday:'short'});
		this.$.start.innerText = date.toLocaleString(undefined, {hour: 'numeric', minute: 'numeric'})
		this.$.art.innerText = record.ClassType.Art.Name;
		this.$.classType.innerText = record.ClassType.Name;
		this.$.students.innerText = record.StudentCount;
		this.$.techniques.innerText = record.TechniqueCount;

		append(this.el);

		this.el.addEventListener(`click`, (evt)=>{
			evt.stopPropagation();
			location=`/classrecord/${record.Id}/edit`;
		});
	}
}

/** 
 * ClassRecordSummaryTable displays a summary table of 
 * class records.
 */
export class ClassRecordSummaryTable extends HTMLElement {
	constructor() {
		super();
		[this.el, this.$] = DojoTemplates(`ClassRecordSummaryTable`);
		this.attachShadow({mode:'open'});
		this.shadowRoot.appendChild(this.el);
		Eventify(this.shadowRoot, this);
	}
	gotoPage(evt) {
		this.fetchPage(evt.detail);
	}
	connectedCallback() {
		this.fetchPage(0);
	}
	fetchPage(page) {
		DojoDeshi.instance().RPC().ClassRecordSummarySearch({
			DojoIds: [parseInt(this.getAttribute(`dojo-id`))],
			RecordsPerPage: 30,
			Page: page,
		}).then(
			([res])=>{
				this.$.pager.setAttribute(`page`,res.Page);
				this.$.pager.setAttribute(`record-count`, res.TotalRecords);
				this.$.pager.setAttribute(`page-count`, Math.ceil(res.TotalRecords/res.RecordsPerPage));

				// Remove all summary records
				while (this.$.summaryHeader.nextSibling) {
					this.$.summaryHeader.nextSibling.remove();
				}
				res.Records.map( r => {
					new ClassRecord( el=>this.$.summaryTable.appendChild(el), r );
				})
			});
	}
}

customElements.define(`class-record-summary-table`, ClassRecordSummaryTable);